import { cn } from '@commenda/utils';
import { Icons } from '../Icons';
import { Tooltip } from '../Tooltip';

interface GuidanceItem {
  text: string;
}

interface GuidanceToolTipProps {
  /** The title displayed in the tooltip */
  title: string;
  /** The main description text */
  description: string;
  triggerLabel?: string;
  /** Side of the trigger to show the tooltip */
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** Alignment of the tooltip relative to the trigger */
  align?: 'start' | 'center' | 'end';
  /** Additional className for the trigger button */
  triggerClassName?: string;
  /** Additional className for the tooltip content */
  contentClassName?: string;
}

function GuidanceToolTip({
  title,
  description,
  side = 'bottom',
  triggerClassName,
}: GuidanceToolTipProps) {
  return (
    <Tooltip
      content={title}
      supportingText={description}
      side={side}
      sideOffset={2}
      asChild
      arrowClassName="fill-bg-solid-hover"
      className="max-w-[320px] text-left rounded-sm bg-bg-solid-hover gap-0.5 overflow-visible py-3"
    >
      <button
        type="button"
        className={cn(
          'inline-flex items-center justify-center rounded-full',
          'text-fg-quaternary',
          'hover:text-fg-quaternary-hover transition-colors',
          triggerClassName
        )}
      >
        <Icons.InfoCircle className="size-3.5" />
      </button>
    </Tooltip>
  );
}

export { GuidanceToolTip };
export type { GuidanceItem, GuidanceToolTipProps };
